import React from "react";

export default function Help() {
  return (
    <section style={{ maxWidth: 820 }}>
      <h1 className="section-title">Помощь по платформе «Современный Врач»</h1>
      <p style={{ color: "#4a4a68", marginTop: -8, marginBottom: 24 }}>
        Короткие ответы на самые частые вопросы — от регистрации до общения в обсуждениях.
        Если не нашли своего вопроса, пишите нам напрямую:{" "}
        <a href="mailto:info@svrach.ru">info@svrach.ru</a>.
      </p>

      <nav
        style={{
          display: "flex", flexWrap: "wrap", gap: "6px 18px",
          padding: "12px 16px", background: "#f7f8fc", border: "1px solid #e2e4f0",
          borderRadius: 10, marginBottom: 28, fontSize: "0.88rem",
        }}
      >
        <a href="#start">Регистрация и вход</a>
        <a href="#sections">Разделы портала</a>
        <a href="#chat-basics">Каналы и подписка</a>
        <a href="#chat-features">Возможности чата</a>
        <a href="#app">Мобильное приложение</a>
        <a href="#profile">Личный кабинет</a>
        <a href="#faq">Частые вопросы</a>
      </nav>

      <div className="article-body">
        <h3 id="start">Регистрация и вход</h3>

        <p><strong>Как зарегистрироваться.</strong> Нажмите «Войти» → «Зарегистрироваться», укажите имя,
          email, пароль и специальность (специальность можно выбрать позже, в личном кабинете). Нужно
          согласиться с обработкой персональных данных — без этого регистрация не пройдёт.</p>

        <p><strong>Подтверждение email.</strong> После регистрации на почту приходит письмо со ссылкой
          подтверждения. Читать портал можно сразу, а вот писать в обсуждениях — только после перехода
          по ссылке из письма. Это защита от спам-аккаунтов.</p>
        <blockquote>Письмо не пришло? Проверьте папку «Спам». Повторно запросить письмо можно
          в личном кабинете, в разделе «Подтверждение email».</blockquote>

        <p><strong>Забыли пароль.</strong> Самостоятельный сброс пароля пока не реализован — напишите
          в поддержку (контакты внизу страницы), и мы поможем восстановить доступ.</p>

        <h3 id="sections">Разделы портала</h3>
        <ul>
          <li><strong>Статьи</strong> — научно-практические материалы с фильтром по специальности</li>
          <li><strong>Материалы</strong> — видео-лекции, мастер-классы, вебинары</li>
          <li><strong>Клинические случаи</strong> — разбор реальной практики, можно публиковать анонимно</li>
          <li><strong>Обсуждения</strong> — форум-чат по каналам специальностей</li>
          <li><strong>Умный поиск</strong> — вопрос обычным языком → ответ по материалам портала</li>
          <li><strong>Сохранённое</strong> — личная подборка «прочитать позже»</li>
          <li><strong>Инструменты</strong> — анонимизация PDF-документов</li>
          <li><strong>События</strong> — календарь конференций по специальностям</li>
        </ul>

        <h3 id="chat-basics">Каналы и подписка</h3>
        <p><strong>Что такое каналы.</strong> Каналы — это темы обсуждений: один на каждую специальность
          плюс общие («Ординаторская» и другие). Список каналов открывается слева от чата.</p>
        <p><strong>Как подписаться на канал.</strong> Нажмите на звёздочку рядом с названием канала.
          Вкладка «Мои» покажет только те каналы, на которые вы подписаны — уведомления приходят именно
          по ним, а не по всем каналам сразу.</p>
        <p><strong>Могу ли я читать без регистрации.</strong> Да, обсуждения открыты для чтения всем.
          Чтобы написать сообщение, нужен подтверждённый аккаунт.</p>

        <h3 id="chat-features">Возможности чата</h3>
        <ul>
          <li><strong>Файлы и фото</strong> — значок скрепки: фото, значок документа: PDF/Word/Excel и другие</li>
          <li><strong>Голосовые</strong> — значок микрофона: тап начинает и завершает запись, у полученного
            голосового есть кнопка «Расшифровать»</li>
          <li><strong>Ответ на сообщение</strong> — иконка со стрелкой у сообщения цитирует его в вашем ответе</li>
          <li><strong>Реакции</strong> — иконка смайлика у сообщения: быстрая эмодзи-реакция</li>
          <li><strong>Опросы</strong> — значок графика в панели ввода: создать вопрос с вариантами ответов</li>
          <li><strong>Закреплённые сообщения</strong> — модератор канала закрепляет важное, оно показывается
            в верхней панели чата</li>
          <li><strong>@Упоминания</strong> — введите <code>@</code> и начните печатать имя, появится
            подсказка с вариантами</li>
          <li><strong>Поиск по истории</strong> — иконка лупы в шапке канала ищет по всем сообщениям</li>
        </ul>

        <h3 id="app">Мобильное приложение</h3>
        <p><strong>Чем приложение отличается от сайта.</strong> Приложение — это только обсуждения
          (тот же чат, что и на сайте, с теми же каналами и историей), без статей и материалов. Если
          нужен полный доступ к контенту — используйте сайт в браузере телефона.</p>
        <p><strong>Как установить.</strong> Приложение пока распространяется файлом <code>.apk</code> напрямую
          (публикация в RuStore готовится). После получения файла:</p>
        <ol>
          <li>Откройте файл на телефоне — Android предупредит про установку из неизвестного источника</li>
          <li>Разрешите установку для этого файла в настройках, которые предложит система</li>
          <li>Войдите тем же email и паролем, что и на сайте — каналы и история будут те же</li>
        </ol>

        <h3 id="profile">Личный кабинет</h3>
        <ul>
          <li><strong>Имя и специальности</strong> — можно указать сразу несколько смежных специальностей</li>
          <li><strong>Имя пользователя (@username)</strong> — по нему коллеги упоминают вас в чате,
            задаётся автоматически, можно изменить</li>
          <li><strong>Смена пароля</strong> — раздел «Смена пароля», нужен текущий пароль</li>
          <li><strong>Подтверждение врача</strong> — загрузите скан диплома или сертификата, после
            проверки появится публичный значок</li>
          <li><strong>Уведомления</strong> — включаются отдельной кнопкой, работают даже при закрытом сайте</li>
          <li><strong>Удаление аккаунта</strong> — в самом низу профиля, потребуется подтверждение паролем</li>
        </ul>

        <h3 id="faq">Частые вопросы</h3>
        <p><strong>Не приходят push-уведомления.</strong> Проверьте, что уведомления включены в личном
          кабинете, и что браузер/телефон не блокирует их в системных настройках. На iPhone push-уведомления
          в браузере работают только после добавления сайта на главный экран.</p>
        <p><strong>Как пожаловаться на сообщение или материал.</strong> Под публикацией есть возможность
          отправить жалобу — её увидят администраторы и редакторы соответствующей специальности.</p>
        <p><strong>Почему сообщение не отправляется.</strong> Скорее всего, ещё не подтверждён email
          (см. раздел «Регистрация и вход») — либо сработал автоматический лимит на частоту сообщений
          при очень быстрой отправке подряд.</p>

        <hr />
        <p>Не нашли ответ? Напишите нам напрямую — <a href="mailto:info@svrach.ru">info@svrach.ru</a>.</p>
      </div>
    </section>
  );
}
